import TableComponent from '../../../components/Table/TableComponent';
import React from 'react';
import { DATAGRID_FILTER_CONFIG } from '../../../constants';
const ReplacementComponent = () => {
  const [loader, setLoader] = React.useState(false);
  const columns = [
    { field: 'Name', headerName: 'Name', width: 170 },
    { field: 'DeviceId', headerName: 'Device Id', width: 170 },
    { field: 'BatchId', headerName: 'Batch Id', width: 170 },
    { field: 'EmployeeId', headerName: 'Employee Id', width: 170 },
    { field: 'DispatchDate', headerName: 'Dispatch Date', width: 170 },
  ];
  // const customSx = DATAGRID_FILTER_CONFIG;
  const rows = [];
  return (
    <TableComponent
      loader={loader}
      TableRows={rows}
      TableColumns={columns}
      // customSx={customSx}
    />
  );
};

export default ReplacementComponent;
